import Vue from "vue";
import { Component } from "vue-property-decorator";
import { TakePictures } from "@/components";
import { IExpedition } from "@/models";
import { ToastHelper } from "@/helpers/ToastHelper";

@Component({
    name: "ExpeditionCardPalettes",
    components: {
        "take-pictures": TakePictures,
    },
})

export default class ExpeditionCardPalettes extends Vue {
    public isTakingPictures: boolean = false;
    public totalPallet: number = 0;
    public incompletePallet: number = 0;
    public detailIncompletePallet: any[] = [];
    constructor() {
        super();
    }

    public get expedition(): IExpedition {
        return this.$store.getters["expeditions/getSelectedExpedition"]();
    }

    public get pictures(): string[] {
        return this.$store.getters["expeditions/getEndLoadPictures"]();
    }

    public created(): void {
        this.$parent.$data.title = "Palettes";
    }

    public previous(): void {
        this.$parent.$data.step--;
    }

    public validateExpedition(): void {
        if (this.pictures.length !== 0) {
            const palletsData = {
                totalPallet: this.totalPallet,
                incompletePallet: this.incompletePallet,
            };
            this.$store.dispatch("expeditions/validateExpedition", { totalPallet: this.totalPallet, incompletePallets: this.detailIncompletePallet });

            this.$router.back();
        } else {
            ToastHelper.general.invalidModel();
        }
    }

    public openPhotos(): void {
        navigator.mediaDevices.enumerateDevices().then(data => {
            if (data.some(x => x.kind === "videoinput")) {
                this.isTakingPictures = !this.isTakingPictures;
            } else {
                ToastHelper.general.noCamera();
            }
        });
    }

    public setDetailIncompletePallet() {
        if (this.detailIncompletePallet.length < this.incompletePallet) {
            const iteration = this.incompletePallet - this.detailIncompletePallet.length;
            for (let i = 0; i < iteration; i++) {
                this.detailIncompletePallet.push({});
            }
        }
        else if (this.detailIncompletePallet.length > this.incompletePallet) {
            this.detailIncompletePallet.splice(this.incompletePallet);
        }
    }
}
